import { context2d } from '@/lib/canvas'
import { createTwoCanvasAnswer } from '../base'

export default createTwoCanvasAnswer(() => {
  const main = (canvas: HTMLCanvasElement, image: HTMLImageElement) => {
    const ctx = context2d(canvas)
    ctx.drawImage(image, 0, 0, image.width, image.height)
    const src = ctx.getImageData(0, 0, image.width, image.height)
    const dst = ctx.createImageData(image.width, image.height)

    const thresholds = [32, 96, 160, 224]

    for (let i = 0; i < src.data.length; i++) {
      if (i % 4 === 3) {
        dst.data[i] = src.data[i]
        continue
      }

      let neer = Number.MAX_SAFE_INTEGER
      let _j = 0

      for (let j = 0; j < thresholds.length; j++) {
        const d = Math.abs(src.data[i] - thresholds[j])
        if (d < neer) {
          neer = d
          _j = j
        }
      }

      dst.data[i] = thresholds[_j]
    }
    ctx.putImageData(dst, 0, 0)
  }

  return { main }
})
